var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conceptual-drawing-wrap",on:{"contextmenu":function($event){$event.stopPropagation();}}},[(_vm.needRenderFocusIcon)?_c('div',{staticClass:"select-component-icon"},[_c('i',{staticClass:"iconfont iconpage-layer-20"})]):_vm._e(),_c('div',{ref:"wrap",staticClass:"inner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }